import {APPROVE_SCHOOL} from "./../../routes";
import customAxios from "../../customAxios";

const approveSchool = async (userId: string) => {
  try {
    return (await customAxios.put(APPROVE_SCHOOL + `/${userId}`)).data;
  } catch (error: unknown) {
    console.error({APPROVE_SCHOOL: error});
    return false;
  }
};

export default approveSchool;
